import type { RenewalRebaseGraceFragmentFragment } from "gql/generated";

export type GraceChoice = {
  /** Unset keeps the saved grace period. */
  graceDays?: number;
  neverExpire?: boolean;
  /** The admin accepted that some members expire on the next nightly run. */
  acknowledged: boolean;
};

export const emptyGraceChoice: GraceChoice = { acknowledged: false };

/** Variables for the preview/apply calls. */
export const graceVariables = (choice: GraceChoice) => ({
  ...(choice.graceDays !== undefined ? { graceDays: choice.graceDays } : {}),
  ...(choice.neverExpire !== undefined
    ? { neverExpire: choice.neverExpire }
    : {}),
});

export const graceBlocksContinue = (
  grace: RenewalRebaseGraceFragmentFragment | null | undefined,
  choice: GraceChoice,
) => !!grace && grace.wouldExpireOnNextSweep > 0 && !choice.acknowledged;
